import { render, staticRenderFns } from "./topicDetails.vue?vue&type=template&id=2e18f544&"
import script from "./topicDetails.vue?vue&type=script&lang=js&"
export * from "./topicDetails.vue?vue&type=script&lang=js&"
import style0 from "./topicDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports